import React from "react";
import { useNavigate } from "react-router-dom";
import { STAFF_MANDATE_ENABLED } from "../../../config/featureFlags";

const MySquadMobileHeader = () => {
  const navigate = useNavigate();

  return (
    <div className="flex justify-between items-center bg-white px-4 py-2 border-t border-[#0000001A]">
      <div>
        <h1 className="text-base font-bold text-[#000000]">My Players</h1>
      </div>
      <div className="flex items-center gap-2">
        <button
          onClick={() => navigate("/agent/invite-player")}
          className="px-3 py-1.5 bg-[#2283FF] text-white rounded-lg text-xs flex items-center gap-2"
        >
          <svg
            className="w-4 h-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 4v16m8-8H4"
            />
          </svg>
          Invite player
        </button>
        {/* TP-Coach-Mandate: mobile twin of the desktop "Invite staff" entry
            (Brief §2.5). Flag-gated; flag off ⇒ header unchanged. */}
        {STAFF_MANDATE_ENABLED && (
          <button
            onClick={() => navigate("/agent/invite-staff")}
            className="px-3 py-1.5 bg-[#2283FF] text-white rounded-lg text-xs flex items-center gap-2"
          >
            <svg
              className="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 4v16m8-8H4"
              />
            </svg>
            Invite staff
          </button>
        )}
      </div>
    </div>
  );
};

export default MySquadMobileHeader;